(() => {
  // Skip re-register if already initialized.
  if (window.SharedSweepsForSearchspring) {
    window.SharedSweepsForSearchspring.refresh?.();
    return;
  }

  const GRID_CONTAINER_SELECTOR = '#product-grid';
  const ITEM_SELECTOR = '#product-grid .grid';
  const IMAGE_WRAPPER_SELECTOR = '.prod-grid-img';
  const DESCRIPTION_SELECTOR = '.product-descr';
  const PRO_PRICE_SELECTOR = '.pro-price';
  const BADGE_SELECTOR = '.ss-rg-badge';
  const BADGE_WRAPPER_CLASS = 'ss-rg-wrapper';
  const STYLE_ID = 'ss-rg-styles';
  const INIT_DELAY_MS = 1200;

  class SharedSweepsForSearchspring {
    constructor() {
      this.products = Array.isArray(window.globalProductObject) ? window.globalProductObject : [];
      this.settings = this.getSettings();
      this.cardObservers = new WeakMap();
      this.pendingCardRaf = new WeakMap();
      this.pendingRun = false;
      this.initTimeout = null;
      this.containerObserver = null;
      this.start();
    }

    refresh() {
      this.products = Array.isArray(window.globalProductObject) ? window.globalProductObject : [];
      this.settings = this.getSettings();
      this.start();
    }

    start() {
      if (this.initTimeout) clearTimeout(this.initTimeout);
      this.initTimeout = setTimeout(() => {
        this.init();
      }, INIT_DELAY_MS);
    }

    getSettings() {
      const shopData = window.ShopData || {};
      const settings = shopData.settings || {};
      const metafields = shopData.metafields || {};
      const sharedsweeps = metafields.sharedsweeps || {};
      const sharedsweepsSettings = settings.sharedsweeps || {};

      const normalizeNumber = (value) => {
        if (value === null || value === undefined || value === '') return NaN;
        const num = Number(value);
        return Number.isNaN(num) ? NaN : num;
      };

      return {
        accent1: sharedsweepsSettings.sweeps_bg_color_base || '#f8e9c0',
        accent2: sharedsweepsSettings.sweeps_multiplier_bg_color_base || '#ebc568',
        fg: sharedsweepsSettings.sweeps_bg_color_base || '#f8e9c0',
        useTierColors: Boolean(sharedsweepsSettings.sweeps_use_tiers_color),
        sweepsUrl: sharedsweepsSettings.sweeps_url || '/',
        sweepsUrlTargetBlank: Boolean(sharedsweepsSettings.sweeps_url_target_blank),
        tiers: [
          {
            key: 'ultra',
            multiplier: normalizeNumber(sharedsweepsSettings.sweeps_ultra_multiplier),
            accent1: sharedsweepsSettings.sweeps_bg_color_ultra,
            accent2: sharedsweepsSettings.sweeps_multiplier_bg_color_ultra,
          },
          {
            key: 'max',
            multiplier: normalizeNumber(sharedsweepsSettings.sweeps_max_multiplier),
            accent1: sharedsweepsSettings.sweeps_bg_color_max,
            accent2: sharedsweepsSettings.sweeps_multiplier_bg_color_max,
          },
          {
            key: 'pro',
            multiplier: normalizeNumber(sharedsweepsSettings.sweeps_pro_multiplier),
            accent1: sharedsweepsSettings.sweeps_bg_color_pro,
            accent2: sharedsweepsSettings.sweeps_multiplier_bg_color_pro,
          },
          {
            key: 'plus',
            multiplier: normalizeNumber(sharedsweepsSettings.sweeps_plus_multiplier),
            accent1: sharedsweepsSettings.sweeps_bg_color_plus,
            accent2: sharedsweepsSettings.sweeps_multiplier_bg_color_plus,
          },
          {
            key: 'base',
            multiplier: normalizeNumber(sharedsweepsSettings.sweeps_base_multiplier),
            accent1: sharedsweepsSettings.sweeps_bg_color_base,
            accent2: sharedsweepsSettings.sweeps_multiplier_bg_color_base,
          },
        ],
        globalMultiplier: Number(sharedsweeps.global_multiplier) || 1,
      };
    }

    getColorsForMultiplier(multiplier) {
      const fallback = {
        accent1: this.settings.accent1,
        accent2: this.settings.accent2,
        fg: this.settings.fg,
      };

      if (!this.settings.useTierColors) return fallback;

      const multNum = Number(multiplier);
      if (Number.isNaN(multNum)) return fallback;

      const matchedTier = (this.settings.tiers || []).find((tier) => (
        tier && !Number.isNaN(tier.multiplier) && tier.multiplier === multNum
      ));

      if (!matchedTier) return fallback;

      const accent1 = matchedTier.accent1 || fallback.accent1;
      const accent2 = matchedTier.accent2 || fallback.accent2;

      return {
        accent1,
        accent2,
        fg: accent1,
      };
    }

    init() {
      this.injectStylesOnce();
      this.run();
      this.observeContainer();
    }

    injectStylesOnce() {
      if (document.getElementById(STYLE_ID)) return;

      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `
        .sharedsweeps-product-card-wrapper .${BADGE_SELECTOR.replace('.', '')} { width: 100%; }
        .${BADGE_WRAPPER_CLASS} { text-align: center; margin: .5rem 0; }
        .${BADGE_SELECTOR.replace('.', '')} {
          --_accent1: var(--ss-accent1, #f8e9c0);
          --_accent2: var(--ss-accent2, #ebc568);
          --_fg: var(--ss-fg, #f8e9c0);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: .6rem;
          padding: .5rem .8rem;
          border-radius: 4px;
          background: var(--_accent1);
          color: #000;
          font-weight: 600;
          font-size: 13px;
          position: relative;
          min-height: 25px;
          max-width: 100%;
          transition: background .2s, box-shadow .2s, border-color .2s;
        }
        .${BADGE_SELECTOR.replace('.', '')}:hover {
          background: linear-gradient(0deg, rgba(159, 214, 209, .20), rgba(159, 214, 209, .20)), #fff;
          box-shadow: 0 2px 10px rgba(0, 0, 0, .06);
        }
        .ss-rg-text { display: inline-flex; align-items: center; gap: .35rem; letter-spacing: .2px; white-space: nowrap; margin-right: 32px; }
        .ss-rg-value { color: #000; font-weight: 800; }
        .ss-rg-bonus { color: #2e7d32; font-weight: 700; margin-left: .15rem; }
        .ss-rg-mult {
          position: absolute;
          top: 0;
          right: 0;
          font-size: 12px;
          line-height: 1;
          background: var(--_accent2);
          color: #000;
          font-weight: 600;
          padding: 0 8px;
          border-radius: 0 4px 4px 0;
          min-height: 25px;
          min-width: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ss-rg-badge.details { margin-top: .25rem; }
        @media (max-width: 640px) {
          .${BADGE_SELECTOR.replace('.', '')} { padding: .45rem .7rem; font-size: 10px; }
          .ss-rg-mult { min-width: 30px; font-size: 11px; padding: .25rem .5rem; }
        }
      `;
      document.head.appendChild(style);
    }

    observeContainer() {
      if (this.containerObserver) return;
      const container = document.querySelector(GRID_CONTAINER_SELECTOR);
      if (!container) return;

      this.containerObserver = new MutationObserver((mutations) => {
        const shouldRun = mutations.some((m) => {
          if (!m.addedNodes.length && !m.removedNodes.length) return false;

          const nodes = [...m.addedNodes, ...m.removedNodes];
          const hasNewCards = nodes.some((node) => {
            if (!(node instanceof HTMLElement)) return false;

            // Ignore mutations caused by our own badge injection to prevent feedback loops.
            if (
              node.classList?.contains('sharedsweeps-product-card-wrapper') ||
              node.classList?.contains(BADGE_WRAPPER_CLASS) ||
              node.matches?.(BADGE_SELECTOR)
            ) {
              return false;
            }

            return node.matches?.(ITEM_SELECTOR) || Boolean(node.querySelector?.(ITEM_SELECTOR));
          });

          if (hasNewCards) return true;

          // If a product card re-renders its inner HTML (without replacing the card node),
          // re-run only when the affected card is missing a badge.
          if (m.target instanceof HTMLElement) {
            if (m.target.closest?.('.sharedsweeps-product-card-wrapper')) return false;
            const gridEl = m.target.closest?.('.grid');
            if (gridEl && container.contains(gridEl) && !gridEl.querySelector(BADGE_SELECTOR)) return true;
          }

          return false;
        });
        if (shouldRun) this.scheduleRun();
      });

      this.containerObserver.observe(container, { childList: true, subtree: true });
    }

    scheduleRun() {
      if (this.pendingRun) return;
      this.pendingRun = true;
      requestAnimationFrame(() => {
        this.pendingRun = false;
        this.run();
      });
    }

    run() {
      const items = Array.from(document.querySelectorAll(ITEM_SELECTOR));
      if (!items.length || !this.products.length) return;

      items.forEach((item) => this.processItem(item));
    }

    processItem(gridEl) {
      if (!gridEl || gridEl.querySelector(BADGE_SELECTOR)) return;

      const productId = this.extractProductId(gridEl);
      if (!productId) return;

      const product = this.findProduct(productId);
      if (!product) return;

      const { metaPrice, multiplier, bonus } = this.computeProductData(product);
      if (!metaPrice || metaPrice <= 0) return;

      const badgeWrapper = this.buildBadge({ productId, metaPrice, multiplier, bonus });
      this.insertBadge(gridEl, badgeWrapper);
      this.updateBadge(badgeWrapper.querySelector(BADGE_SELECTOR), gridEl);
      this.observeCard(gridEl);
    }

    extractProductId(gridEl) {
      const proPriceEl = gridEl.querySelector(PRO_PRICE_SELECTOR);
      if (!proPriceEl) return null;

      const idFromAttr = proPriceEl.getAttribute('id') || '';
      const idMatch = idFromAttr.match(/pro-price-?(\d+)/i);
      if (idMatch && idMatch[1]) return Number(idMatch[1]);

      const dataId = proPriceEl.getAttribute('data-product-id') || gridEl.getAttribute('data-product-id');
      if (dataId) return Number(dataId);

      return null;
    }

    findProduct(id) {
      return this.products.find((p) => String(p.id) === String(id));
    }

    computeProductData(product) {
      const override = product?.metafields?.sharedsweeps?.priceoverride;
      const productPriceCents = Number(product.price) || 0;
      const basePrice = productPriceCents > 0 ? productPriceCents / 100 : 0;
      const metaPrice = override !== null && override !== undefined && override !== '' ? Number(override) : basePrice;

      const productMultRaw = product?.metafields?.sharedsweeps?.multiplier;
      const productMult = productMultRaw !== undefined && productMultRaw !== null && productMultRaw !== '' ? Number(productMultRaw) : NaN;
      const multiplier = !Number.isNaN(productMult) && productMult > this.settings.globalMultiplier
        ? productMult
        : this.settings.globalMultiplier;

      const bonusRaw = product?.metafields?.sharedsweeps?.bonusEntries;
      const bonus = bonusRaw ? Number(bonusRaw) : 0;

      return { metaPrice, multiplier, bonus };
    }

    buildBadge({ productId, metaPrice, multiplier, bonus }) {
      const outer = document.createElement('a');
      outer.className = 'sharedsweeps-product-card-wrapper';
      outer.href =  this.settings.sweepsUrl;
      outer.target = this.settings.sweepsUrlTargetBlank ? '_blank' : '_self';
      if ( this.settings.sweepsUrlTargetBlank) outer.rel = 'noopener noreferrer';

      const wrapper = document.createElement('div');
      wrapper.className = BADGE_WRAPPER_CLASS;
      wrapper.dataset.ssScope = 'product-card';

      const badge = document.createElement('span');
      badge.className = BADGE_SELECTOR.replace('.', '');
      badge.dataset.ss = '';
      badge.dataset.productId = productId;
      badge.dataset.metaPrice = metaPrice;
      badge.dataset.mult = multiplier;
      badge.dataset.bonus = bonus;
      const colors = this.getColorsForMultiplier(multiplier);
      badge.style.setProperty('--ss-accent1', colors.accent1);
      badge.style.setProperty('--ss-accent2', colors.accent2);
      badge.style.setProperty('--ss-fg', colors.fg);

      const text = document.createElement('span');
      text.className = 'ss-rg-text';

      const value = document.createElement('span');
      value.className = 'ss-rg-value';
      value.dataset.ssValue = '';
      value.textContent = Math.floor(metaPrice * multiplier) + (bonus || 0);

      text.appendChild(value);
      text.appendChild(document.createTextNode(' ENTRIES'));

      if (bonus > 0) {
        const bonusEl = document.createElement('span');
        bonusEl.className = 'ss-rg-bonus';
        bonusEl.textContent = `+ ${bonus}`;
        text.appendChild(bonusEl);
      }

      const multEl = document.createElement('span');
      multEl.className = 'ss-rg-mult';
      multEl.setAttribute('aria-label', `${multiplier}x multiplier`);
      multEl.textContent = `${multiplier}X`;

      badge.appendChild(text);
      badge.appendChild(multEl);
      wrapper.appendChild(badge);
      outer.appendChild(wrapper);

      return outer;
    }

    insertBadge(gridEl, badgeWrapper) {
      const imageEl = gridEl.querySelector(IMAGE_WRAPPER_SELECTOR);
      const descrEl = gridEl.querySelector(DESCRIPTION_SELECTOR);

      if (imageEl && imageEl.parentNode) {
        imageEl.insertAdjacentElement('afterend', badgeWrapper);
      } else if (descrEl && descrEl.parentNode) {
        descrEl.insertAdjacentElement('beforebegin', badgeWrapper);
      } else {
        gridEl.appendChild(badgeWrapper);
      }
    }

    parseMoney(text) {
      if (!text) return NaN;
      const cleaned = String(text).replace(/[^0-9,.\-]/g, '').replace(/\.(?=.*\.)/g, '').replace(',', '.');
      const num = parseFloat(cleaned);
      return Number.isNaN(num) ? NaN : num;
    }

    parseDisplayedPrice(gridEl) {
      const proPriceEl = gridEl.querySelector(PRO_PRICE_SELECTOR);
      if (!proPriceEl) return null;

      const candidates = [
        proPriceEl.querySelector('.sale'),
        proPriceEl.querySelector('.money'),
        proPriceEl,
      ];

      for (const node of candidates) {
        if (!node) continue;
        const value = this.parseMoney(node.textContent || node.innerText);
        if (!Number.isNaN(value)) return value;
      }

      const attr = proPriceEl.getAttribute('data-regular-price');
      if (attr) {
        const raw = Number(attr);
        if (!Number.isNaN(raw)) return raw > 1000 ? raw / 100 : raw;
      }

      return null;
    }

    updateBadge(badgeEl, gridEl) {
      if (!badgeEl) return;

      const metaPrice = Number(badgeEl.dataset.metaPrice) || 0;
      const mult = Number(badgeEl.dataset.mult) || 1;
      const bonus = Number(badgeEl.dataset.bonus) || 0;
      const displayedPrice = this.parseDisplayedPrice(gridEl);
      const price = displayedPrice || metaPrice;
      if (!price) return;

      const entries = Math.floor(price * mult) + bonus;
      const valueEl = badgeEl.querySelector('[data-ss-value]');
      if (valueEl) valueEl.textContent = entries;
    }

    observeCard(gridEl) {
      if (this.cardObservers.has(gridEl)) return;

      const observer = new MutationObserver(() => this.scheduleCardUpdate(gridEl));
      observer.observe(gridEl, { subtree: true, childList: true, characterData: true });
      this.cardObservers.set(gridEl, observer);
    }

    scheduleCardUpdate(gridEl) {
      if (this.pendingCardRaf.has(gridEl)) return;

      const rafId = requestAnimationFrame(() => {
        this.pendingCardRaf.delete(gridEl);
        const badge = gridEl.querySelector(BADGE_SELECTOR);
        if (badge) {
          this.updateBadge(badge, gridEl);
        } else {
          this.processItem(gridEl);
        }
      });

      this.pendingCardRaf.set(gridEl, rafId);
    }
  }

  window.SharedSweepsForSearchspring = new SharedSweepsForSearchspring();
})();
